
export const tableOption = {
    border: true,
    stripe: true,
    align: 'center',
    addBtn: false,
    columnBtn: false,
    menu:false,
    column: [
    {
      label: '圈子',
      prop: 'circleName',
      overHidden: true,
      span: 24,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 200,
      span: 24,
    },
    {
      label: '时间',
      prop: 'date',
      span: 24,
    },
    {
      label: '用户量',
      prop: 'circleJoinCount',
      span: 24,
    },
    {
      label: '帖子量',
      prop: 'totalPostCount',
      span: 24,
    },
    {
      label: '点赞量',
      prop: 'totalLikeCount',
      span: 24,
    },
    {
      label: '评论量',
      prop: 'totalCommentCount',
      span: 24,
    },
    {
      label: '收藏量',
      prop: 'totalFavoriteCount',
      span: 24,
    }]
}